import AppointmentResource from 'App/babel/resources/Appointment';
import NotificationService from 'App/babel/NotificationService';
import logError from 'Helpers/logError';
import type { Span } from './calendarDrag';

export async function rescheduleAppointment(id: number, span: Span): Promise<boolean> {
	try {
		await AppointmentResource.save(
			{ id, date: span.date, endDate: span.endDate },
			{ skipNotification: true, skipErrorNotification: true }
		);
		return true;
	} catch (error) {
		NotificationService.add({
			icon: 'times',
			style: NotificationService.style.ERROR,
			title: 'default.error',
			body: 'calendar.error.reschedule'
		});
		logError(error, `Could not reschedule appointment ${id}`);
		return false;
	}
}
